import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useCaseCollaboration } from './CaseCollaborationContext';

/**
 * Renders remote collaborators' in-progress text over an input area.
 * Uses per-tab sessionId so the same user in two browsers sees each other.
 */
export default function LiveFieldOverlay({
  jurorId,
  field,
  multiline = false,
  children,
}) {
  const { getLiveStatesForJuror } = useCaseCollaboration();
  const liveStates = getLiveStatesForJuror(jurorId).filter((state) => {
    if (field === 'nameAndId') {
      return state.nameAndId != null && state.activeField === 'nameAndId';
    }
    if (field === 'comments') {
      return state.comments != null;
    }
    return false;
  });

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      {children}
      {liveStates.map((state) => {
        const text =
          field === 'nameAndId' ? state.nameAndId ?? '' : state.comments ?? '';

        if (!text) {
          return null;
        }

        return (
          <Box
            key={state.sessionId}
            aria-hidden
            sx={{
              position: 'absolute',
              pointerEvents: 'none',
              zIndex: 4,
              overflow: 'hidden',
              ...(multiline
                ? {
                    top: 56,
                    left: 12,
                    right: 12,
                    bottom: 8,
                  }
                : {
                    top: '50%',
                    left: 14,
                    right: 14,
                    transform: 'translateY(-50%)',
                  }),
            }}
          >
            <Typography
              component="div"
              sx={{
                color: state.color,
                opacity: 0.65,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontSize: multiline ? '1rem' : '0.875rem',
                lineHeight: multiline ? 1.5 : 1.43,
                fontFamily: 'inherit',
                fontWeight: 500,
              }}
            >
              {text}
            </Typography>
            {!multiline && state.cursor != null && (
              <Box
                sx={{
                  display: 'inline-block',
                  width: 2,
                  height: '1em',
                  ml: 0.25,
                  verticalAlign: 'text-bottom',
                  bgcolor: state.color,
                }}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
}
